import { StartupState } from '../reducers/app';

// Startup
export type StartupAction = { type: 'SET_STARTUP_STATE'; startupState: StartupState };

export function setStartupState(startupState: StartupState): StartupAction {
  return { type: 'SET_STARTUP_STATE', startupState };
}
